module.exports = __webpack_public_path__ + "img/解决方案_BMS_灰.6aeda8ca.svg";